/**
 * Shim for @clariness/password-field: re-exports with optional pointer/crossOrigin props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import {
  PasswordField as OrigPasswordField,
  type PasswordFieldProps,
} from '~clariness-password-field';

type OptionalProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export type { PasswordFieldProps };
export const PasswordField =
  OrigPasswordField as React.ForwardRefExoticComponent<
    Omit<React.ComponentProps<typeof OrigPasswordField>, keyof OptionalProps> &
      OptionalProps &
      React.RefAttributes<HTMLInputElement>
  >;
